import React, { useEffect, useRef } from 'react';
import { el, setChildren } from 'redom';

function IconSettingsReact(props) {
  const mount = useRef(null);
  const panel = useRef(null);
  const current = useRef(props);
  current.current = props;

  useEffect(function refresh() {
    if (panel.current !== null) {
      try {
        panel.current.refresh();
      } catch (exception) {
        return;
      }
    }
  }, [props.value]);

  useEffect(function load() {
    let unloaded = false;
    const target = mount.current;
    const configuration = {
      attached: props.attached,
      read() { return current.current.read(); },
      write(changes) { current.current.write(changes); },
      remove() { current.current.remove(); }
    };
    async function loadPanel() {
      try {
        const module = await import('./');
        if (unloaded === false) {
          panel.current = new module.default(configuration);
          setChildren(target, [panel.current]);
          current.current.onResize();
        }
      } catch (exception) {
        if (unloaded === false) {
          setChildren(target, [el('p', 'These settings could not be loaded. Refresh the page to try again.')]);
        }
      }
    }
    setChildren(target, [el('.simple-dialog-loading-content', [el('ht-spinner', { size: 'small' })])]);
    loadPanel();
    return function unload() { unloaded = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="icon-settings-react" ref={mount} contentEditable={false} />;
}

export default IconSettingsReact;
